import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ActivityFeed = () => {
  const [filter, setFilter] = useState('all');

  const activities = [
    {
      id: 1,
      type: 'booking',
      title: 'Nouvelle réservation confirmée',
      description: 'DJ Martin Dubois - Club Le Zenith, Paris',
      amount: 450.00,
      timestamp: new Date('2024-09-06T18:30:00'),
      icon: 'Calendar',
      status: 'success'
    },
    {
      id: 2,
      type: 'commission',
      title: 'Commission versée',
      description: 'Paiement pour la période du 01-31 août 2024',
      amount: 1250.75,
      timestamp: new Date('2024-09-06T14:15:00'),
      icon: 'DollarSign',
      status: 'success'
    },
    {
      id: 3,
      type: 'campaign',
      title: 'Nouvelle campagne lancée',
      description: 'Festival d\'été 2024 - Promotion spéciale',
      timestamp: new Date('2024-09-06T10:45:00'),
      icon: 'Megaphone',
      status: 'info'
    },
    {
      id: 4,
      type: 'message',
      title: 'Nouveau message reçu',
      description: 'Message de l\'équipe Artis.io concernant les nouvelles fonctionnalités',
      timestamp: new Date('2024-09-05T16:20:00'),
      icon: 'MessageSquare',
      status: 'info'
    },
    {
      id: 5,
      type: 'booking',
      title: 'Réservation en attente',
      description: 'DJ Sophie Laurent - Bar Le Groove, Lyon',
      amount: 320.00,
      timestamp: new Date('2024-09-05T12:30:00'),
      icon: 'Clock',
      status: 'warning'
    },
    {
      id: 6,
      type: 'achievement',
      title: 'Objectif atteint !',
      description: 'Vous avez dépassé votre objectif mensuel de commissions',
      timestamp: new Date('2024-09-04T09:15:00'),
      icon: 'Trophy',
      status: 'success'
    }
  ];

  const filteredActivities = filter === 'all' 
    ? activities 
    : activities?.filter(activity => activity?.type === filter);

  const formatTimestamp = (timestamp) => {
    const now = new Date();
    const diff = now - timestamp;
    const minutes = Math.floor(diff / 60000);
    const hours = Math.floor(diff / 3600000);
    const days = Math.floor(diff / 86400000);

    if (minutes < 60) {
      return `Il y a ${minutes} min`;
    } else if (hours < 24) {
      return `Il y a ${hours}h`;
    } else {
      return `Il y a ${days}j`;
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'success': return 'text-success bg-success/10';
      case 'warning': return 'text-warning bg-warning/10';
      case 'info': return 'text-accent bg-accent/10';
      default: return 'text-muted-foreground bg-muted';
    }
  };

  const filterOptions = [
    { value: 'all', label: 'Toutes', icon: 'List' },
    { value: 'booking', label: 'Réservations', icon: 'Calendar' },
    { value: 'commission', label: 'Commissions', icon: 'DollarSign' },
    { value: 'message', label: 'Messages', icon: 'MessageSquare' }
  ];

  return (
    <div className="bg-card rounded-lg border border-border shadow-sm">
      <div className="p-6 border-b border-border">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold text-card-foreground">Activité récente</h3>
          <Button variant="ghost" size="sm" iconName="MoreHorizontal" iconSize={16}>
          </Button>
        </div>
        
        <div className="flex space-x-2 overflow-x-auto">
          {filterOptions?.map((option) => (
            <Button
              key={option?.value}
              variant={filter === option?.value ? 'default' : 'ghost'}
              size="sm"
              onClick={() => setFilter(option?.value)}
              iconName={option?.icon}
              iconPosition="left"
              iconSize={14}
            >
              {option?.label}
            </Button>
          ))}
        </div>
      </div>
      <div className="max-h-96 overflow-y-auto">
        {filteredActivities?.length === 0 ? (
          <div className="p-6 text-center">
            <Icon name="Inbox" size={48} className="text-muted-foreground mx-auto mb-3" />
            <p className="text-muted-foreground">Aucune activité pour ce filtre</p>
          </div>
        ) : (
          <div className="divide-y divide-border">
            {filteredActivities?.map((activity) => (
              <div key={activity?.id} className="p-4 hover:bg-muted/50 transition-colors duration-150">
                <div className="flex items-start space-x-3">
                  <div className={`flex items-center justify-center w-8 h-8 rounded-full ${getStatusColor(activity?.status)}`}>
                    <Icon name={activity?.icon} size={16} />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center justify-between">
                      <p className="text-sm font-medium text-card-foreground truncate">
                        {activity?.title}
                      </p>
                      <span className="text-xs text-muted-foreground whitespace-nowrap ml-2">
                        {formatTimestamp(activity?.timestamp)}
                      </span>
                    </div>
                    <p className="text-sm text-muted-foreground mt-1">
                      {activity?.description}
                    </p>
                    {activity?.amount && (
                      <p className="text-sm font-semibold text-success mt-1">
                        +{new Intl.NumberFormat('fr-FR', {
                          style: 'currency',
                          currency: 'EUR'
                        })?.format(activity?.amount)}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      <div className="p-4 border-t border-border">
        <Button variant="ghost" size="sm" fullWidth iconName="ArrowRight" iconPosition="right">
          Voir toute l'activité
        </Button>
      </div>
    </div>
  );
};

export default ActivityFeed;